import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    resourcesearchList: null,
};

export const resourcesearchSlice = createSlice({
    name: "resourcesearch",
    initialState,
    reducers: {
        updateResourceSearch: (state, action) => {
            state.resourcesearchList = action.payload;
        },
        clearResourceSearch: (state) => {
            state.resourcesearchList = null;
        },        
    },
});

export const { updateResourceSearch, clearResourceSearch } = resourcesearchSlice.actions;

export default resourcesearchSlice.reducer;